module.exports = __webpack_public_path__ + "static/section-1-img-2-64826bbf560f3e346abca37d5274d1bf.png";